import { FC } from "react";
import LogoIcon from "../../ui/assets/svg/vviinn-logo.svg?react";
import { MenuPrimary, MenuAdmin } from "./Menus";
import { vviinnLinkProps } from "./constants";

export const Sidebar: FC<React.PropsWithChildren<{}>> = () => {
  return (
    <>
      <div className="flex h-16 shrink-0 items-center bg-black px-4 py-4 dark:border-b dark:border-stone-900">
        <a
          {...vviinnLinkProps}
          className="mx-auto flex shrink-0 items-center px-4"
        >
          <LogoIcon width="112" height="28" />
        </a>
      </div>
      <div className="flex grow flex-col py-2">
        <MenuPrimary closeMenuMobile={() => {}} />
        <MenuAdmin closeMenuMobile={() => {}} />
      </div>
    </>
  );
};
